import React from "react";

export default function Contact() {
  return (
    <div className="max-w-5xl mx-auto px-4 py-10">
      <h1 className="text-3xl font-bold mb-4">Contact Us</h1>
      <ul className="space-y-2 text-slate-800">
        <li>Email: <a className="text-sky-600 hover:underline" href="mailto:nishatchadha@gmail.com">nishatchadha@gmail.com</a></li>
        <li>Phone/WhatsApp: <a className="text-sky-600 hover:underline" href="tel:+919833255196">+91 98332 55196</a></li>
        <li>Address: Bandra West, Mumbai, India</li>
      </ul>
      <p className="text-slate-700 mt-4">We aim to respond within 1–2 business days.</p>
    </div>
  );
}
